import {
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { StudentCoinService } from '@core/services/api/student-coin.service';
import { CoinSource } from '@models/coin';

@Component({
  template: `
    <div class="coin">
      <button class="coin-btn fade-in" (click)="popBubble()">
        <img
          #coinImg
          class="coin-img"
          src="assets/img/coin/bubble_coin.gif"
          alt="coin spinning"
        />
      </button>
    </div>
  `,
  selector: 'app-student-coin',
  styleUrls: ['./coin.component.scss'],
})
export class TeacherCoinComponent implements OnInit {
  @ViewChild('coinImg') imgRef: ElementRef<HTMLImageElement>;
  id: number;
  containerRef: ViewContainerRef;
  ref: ComponentRef<TeacherCoinComponent>;
  x: number;
  y: number;
  stop: boolean = false;
  private animationReq: number;
  constructor(private studentCoinService: StudentCoinService) {}

  ngOnInit(): void {
    this.startAnimationLoop();
  }

  popBubble(playSound: boolean = true): void {
    if (playSound) {
      const audio = new Audio('assets/media/collect.wav');
      audio.play();
    }
    this.imgRef.nativeElement.src = 'assets/img/coin/bubble_pop_coin.gif';
    this.imgRef.nativeElement.classList.add('fade-out');
    this.stop = true;

    setTimeout(() => {
      this.imgRef.nativeElement.classList.add('faded');
      try {
        this.containerRef.remove(this.id);
      } catch (e) {
        this.containerRef.remove();
      }
    }, 2000);
  }

  private startAnimationLoop(): void {
    this.animationReq = requestAnimationFrame(this.tick.bind(this));
  }

  private tick() {
    if (this.stop) {
      cancelAnimationFrame(this.animationReq);
      return;
    }
    this.update();
    this.animationReq = requestAnimationFrame(this.tick.bind(this));
  }

  private update() {
    this.ref.location.nativeElement.style.top = this.y + 'px';
    this.ref.location.nativeElement.style.left = this.x + 'px';
    this.y -= 1;
    if (this.y < 0) {
      this.imgRef.nativeElement.src = 'assets/img/coin/bubble_pop_coin.gif';
      this.popBubble(false);
    }
  }
}
